const style = {
  paddingTop: '25px',
};


export default {
  style,
};



// WEBPACK FOOTER //
// ./src/scenes/Admins/components/AdminSettings/components/UserSelect/components/Search/style.js